import type { ValidationResult } from "@unique-wool/specs-validation";
import { validateFamily } from "@unique-wool/specs-validation";
import { ObservableModelRoot } from "./observable";
import type {
  FamilySpecsModelValidationContext,
  FamilySpecsModelSnapshot,
  SpecsCatalog,
} from "./types";
import { SpecsFamilyModel } from "./families/SpecsFamilyModel";
import { SpecsFamilyVersionModel } from "./families/SpecsFamilyVersionModel";

export class SpecsFamiliesModel extends ObservableModelRoot {
  family!: SpecsFamilyModel;
  private validationContext!: FamilySpecsModelValidationContext;

  constructor() {
    super();
    this.defineObservableValue("family", new SpecsFamilyModel());
    this.family.defaultVersion = "1.0";
    this.family.versions = [new SpecsFamilyVersionModel()];
    this.validationContext = {
      products: [],
    };
  }

  restore(snapshot: FamilySpecsModelSnapshot) {
    this.family.restore(snapshot);
    return this;
  }

  save(): FamilySpecsModelSnapshot {
    return this.family.save();
  }

  setValidationContext(context: FamilySpecsModelValidationContext) {
    this.validationContext = {
      products: context.products ?? [],
    };
    return this;
  }

  buildValidationSpecs(
    context: FamilySpecsModelValidationContext = this.validationContext
  ) {
    return {
      families: [this.save()],
      fabrics: [],
      decorations: [],
      products: context.products ?? [],
    };
  }

  async validate(
    context: FamilySpecsModelValidationContext = this.validationContext
  ): Promise<ValidationResult> {
    const issues = await validateFamily(this.buildValidationSpecs(context));
    return {
      valid: issues.length === 0,
      issues,
    };
  }

  static fromCatalog(specs: SpecsCatalog, familyName: string) {
    const family = Array.isArray(specs.families)
      ? specs.families.find((candidate) => candidate?.name === familyName)
      : null;

    if (!family) {
      return null;
    }

    return new SpecsFamiliesModel().restore(family as FamilySpecsModelSnapshot);
  }
}
